module.exports = __webpack_public_path__ + "static/media/aime_musique.793a3e66.mp3";